export function calculateWorkload(obj_size, original_name){
    let tot_cores = navigator.hardwareConcurrency;
    const chunk_size = 40000;
    let tot_chunks = Math.floor(obj_size/chunk_size) + 1;
    let chunk_remainder = obj_size % chunk_size;
    //if 0 we dont have to worry
    let chunks_per_core = (Math.floor(tot_chunks/tot_cores));
    let chunk_core_remainder = tot_chunks % tot_cores;
    console.log(`total cores: ${tot_cores}`)
    console.log(`tot_chunks: ${tot_chunks}\nchunks_per_core: ${chunks_per_core}`);
    //if chunk_core_remainder != 0 then add one to chunk per core on the last assignment
    console.log(`remainders: \n\n chunk_remainder ${chunk_remainder}\nchunk_core_remainder: ${chunk_core_remainder}`)
    let cnt = 0;
    let chunk_config = [];
    //needed: chunk naming convention

    for (cnt; cnt < tot_chunks;cnt++){
        let cur_chunk = cnt * (chunk_size - 1);
        chunk_config.push(cur_chunk);
        //console.log(cur_chunk);
        /*if (cnt % 2  > 0){
            console.log('\n\n\n')
            //found byte range for packet
            //make object here
        }*/
    }
    if (chunk_remainder > 0){
        let fin_packet = obj_size - chunk_config[tot_chunks - 1];
        chunk_config.push(fin_packet)
        /*console.log(fin_packet)
        console.log(chunk_config.length)
        console.log(`total ${fin_packet + chunk_config[tot_chunks - 1]}`);*/
    }
    
    console.log(`chunk_config length ${chunk_config.length}`)
    //needed: naming convention and we are ready  go
}

export function showProgress(){
    return null;
}
